import { LinkBanner, Page } from '@/components';
import StakingIcon from '@/components/icons/Staking';
import StakingModal from './StakingModal';

import { useSearchParams } from '@/hooks';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import HistoricGraphs from './HistoricGraphs';
import LSESKYFarmsKpi from './LSESKYFarmsKpi';

export default function StakingPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  return (
    <Page
      title={
        <Flex gap="2xs" alignItems="center">
          <StakingIcon size="5" />
          <Heading size="1">Staking</Heading>
          <StakingModal />
        </Flex>
      }>
      <LinkBanner
        text="Start Staking"
        linkTo="https://app.sky.money/?network=ethereum&widget=stake">
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Staking Engine</Heading>
          <br />
          The Staking Engine is a Sky Protocol module that accepts staked SKY to
          encourage reliable governance participation and strengthen protocol
          security. Rewards are issued by the protocol to incentivize this
          participation and alignment. The module also supports creating
          positions that use staked SKY as collateral to generate and borrow
          USDS, and it enables delegation of SKY’s governance voting power.
          Operation is non-custodial; keys remain with the holder and actions
          execute on-chain under protocol rules.
        </Box>
      </LinkBanner>
      <LSESKYFarmsKpi daysAgo={daysAgo} />
      <HistoricGraphs />
    </Page>
  );
}
